// Páginas
export * from './pages/CrearProducto';
export * from './pages/EditarProducto';
export * from './pages/ListarProductos';
export { CategoriasPage } from './pages/CategoriasPage';

// Hooks compartidos
export * from './hooks';

// Utilidades compartidas
export * from './utils';

// Tipos
export * from './types/producto.types';
export * from './types/categoria.types';

// Nuevas exportaciones del módulo
export { ProductosPage } from './pages/ProductosPage';
export { ProductFormPage } from './pages/ProductFormPage';
export {
  ProductList,
  ProductCard,
  ProductForm,
  ProductDetail,
  ProductSearch,
} from './components';
export { useProductos, useProductoForm } from './hooks';
export { ProductoService } from './services';
export type {
  Producto,
  CreateProductoInput,
  UpdateProductoInput,
  ProductoListResponse,
  ApiResponse,
} from './types';

// Módulo de Productos
export const ProductsModule = {
  name: 'Productos',
  description: 'Módulo de gestión de productos con arquitectura feature-first',
  version: '2.0.0',
  features: ['form', 'list', 'detail'],
}; 